import { getPaymentMethods, } from '../types'
import HttpService from '../../services/HttpService'

export const getPaymentMethodsList = () => {
  return async dispatch => {
    
    dispatch({ type: getPaymentMethods.GET_PAYMENT_METHODS_PENDING, })

    let storage
    try {
      storage = JSON.parse(localStorage.getItem("user-token"))
    } catch (err) {
      return dispatch({ 
        type: getPaymentMethods.GET_PAYMENT_METHODS_ERROR, 
        payload: message,
      })
    }
    const http = new HttpService()
    await http.getData(
      '/users/'+storage.data.user.id+'/payment-methods',
      "user-token",
    )
      .then(res => {
        dispatch({
          type: getPaymentMethods.GET_PAYMENT_METHODS_SUCCESS,
          payload: res.data.data,
        })
      })
      .catch(err => {
        let message
        if ("ERR_NETWORK" === err.code) {
          message = "Server unavailable."
        } else if (err.response?.data?.message) {
          message = err.response.data.message
        } else {
          message = "Something went wrong. Please come back later."
        }
        dispatch({ 
          type: getPaymentMethods.GET_PAYMENT_METHODS_ERROR, 
          payload: message,
        })
      })
  }
}